import Cookies from "js-cookie"
import type { UserAuthCookie } from "src/types"
import {
  setHasCookieLocalStorage,
  noticeError,
} from "src/utils"

const userAuthCookieKey = "lS_user_auth"

const cookieAttributes = {
  sameSite: "strict" as const, // do not include in cross-site requests
  secure: true, // requires https
  expires: 7, // expires in 7 days
}

function removeCookie() {
  /*
   * remove a cookie that was saved before cookieAttributes were defined
   * this would be version 4.0.x -> 4.1.0
   */
  Cookies.remove(userAuthCookieKey)

  /*
   * remove a cookie that was saved after cookieAttributes were defined
   * this would be version 4.1.1 onward
   */
  Cookies.remove(
    userAuthCookieKey,
    cookieAttributes,
  )
}

export function getUserAuthCookie(): UserAuthCookie | null {
  const userAuthString = Cookies.get(userAuthCookieKey)

  if (!userAuthString) {
    return null
  }

  try {
    return JSON.parse(userAuthString) as unknown as UserAuthCookie
  } catch (e) {
    noticeError(
      e,
      "AuthCookieParse",
    )

    removeCookie()
  }

  return null
}

export function setUserAuthCookie(cookieData: UserAuthCookie | null) {
  if (cookieData === null) {
    removeCookie()
    setHasCookieLocalStorage("false")
  } else {
    Cookies.set(
      userAuthCookieKey,
      JSON.stringify(cookieData),
      cookieAttributes,
    )
    setHasCookieLocalStorage("true")
  }
}
